export const obtenerDiasDisponiblesHabitaciones = (arrHabitaciones) => {

    let cont = 0
    for (let i = 0; i < arrHabitaciones.length; i++) {
        if (arrHabitaciones[i].estado === 'Libre') {
            cont++
        }
    }

    return cont * 30

}